import { get, push, ref, update } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetItemData from "../../../Comman/GetItemData";

const AddAssignerUserItemDataInFirebase = async (state, dispatch, itemData, userID, islocal, ownerUid) => {
  if (!ownerUid) return null;
  const USERID = state?.USERID || userID;
  if (!USERID) return null;

  try {
    const itemsRef = ref(database, `invoiceGenerator/users/${ownerUid}/items`);

    if (!Array.isArray(itemData)) return;

    if (!islocal) {
      // 🔍 Non-local data: check and update or push
      const snapshot = await get(itemsRef);
      const existingItems = snapshot.val() || {};
      const existingItemsArray = Object.entries(existingItems); // [ [key, value], ... ]

      for (let newItem of itemData) {
        let matchedItem = null;
        let matchedKey = null;

        for (let [key, existingItem] of existingItemsArray) {
          if (
            existingItem.name?.toLowerCase() === newItem.name?.toLowerCase()
          ) {
            matchedItem = existingItem;
            matchedKey = key;
            break;
          }
        }

        if (matchedItem && matchedKey) {
          const itemUpdateRef = ref(database, `invoiceGenerator/users/${ownerUid}/items/${matchedKey}`);
          await update(itemUpdateRef, {
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            ...matchedItem,
            defaultPrice: newItem.price?.toString(),
            subtitle: newItem.subtitle?.toString() || "",
            updatedDate: Date.now().toString(),
            companyId: newItem.companyId || matchedItem.companyId || "", // Keep companyId
          });
        } else {
          const cleanedItem = {
            createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            createdById: state?.USERID || null,
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            updatedById: state?.USERID || null,
            itemId: newItem.itemId?.toString() || Date.now().toString(),
            name: newItem?.name?.toString() || "",
            defaultPrice: newItem.price?.toString() || "0.00",
            purchasePrice: "0.00",
            subtitle: newItem.subtitle?.toString() || "",
            createdDate: Date.now().toString(),
            updatedDate: Date.now().toString(),
            companyId: newItem.companyId || "" // Save companyId
          };
          await push(itemsRef, cleanedItem);
        }
      }
    } else {
      // 📦 Local data: add all items directly
      for (let newItem of itemData) {
        const cleanedItem = {
          createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
          updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
          itemId: newItem.itemId?.toString() || Date.now().toString(),
          name: newItem?.name?.toString() || "",
          defaultPrice: newItem.price?.toString() || "0.00",
          purchasePrice: "0.00",
          subtitle: newItem.subtitle?.toString() || "",
          createdDate: Date.now().toString(),
          updatedDate: Date.now().toString(),
          companyId: newItem.companyId || "" // Save companyId
        };
        await push(itemsRef, cleanedItem);
      }
    }

    await GetItemData(state, dispatch);

  } catch (error) {
    console.error("Error adding item to Firebase:", error);
    return null;
  }
};

export default AddAssignerUserItemDataInFirebase;
